import React, { CSSProperties } from 'react';
import TileGrid from './TileGrid';
import { TileGridSectionProps } from './Types';
import useMediaQuery from '../../../hooks/useMediaQuery';

const TilesGridSection = ({
  tiles,
  backgroundImage,
  backgroundColor,
  tileFontStyle,
}: TileGridSectionProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  const backgroundStyle: CSSProperties = backgroundImage
    ? {
        background: `url("${backgroundImage}")`,
        backgroundPosition: 'center',
        opacity: isMobile ? 0.9 : 0.6,
      }
    : {};

  const containerStyle: CSSProperties = {
    width: '100%',
    height: '540px',
    minHeight: '540px',
    flexShrink: 0,
    aspectRatio: '721.66/540.00',
    position: 'relative',
  };

  return (
    <div
      style={containerStyle}
      className="w-full flex justify-center items-center"
    >
      {backgroundImage && (
        <div
          style={backgroundStyle}
          className="absolute inset-0"
          aria-hidden="true"
        ></div>
      )}
      <div className="relative z-20 w-full h-full  flex justify-center items-center">
        <TileGrid
          tiles={tiles}
          backgroundColor={backgroundColor}
          tileFontStyle={tileFontStyle}
        />
      </div>
    </div>
  );
};

export default TilesGridSection;
